import React from "react";
import Label from "componentsTemplate/Label/Label";
import { get } from "lodash";

const Switch = ({
  label,
  fieldName,
  formData,
  handleChange,
  extraProps = {},
  classe = "block",
}: any) => {
  let value = get(formData, fieldName, false); // Padrão: false

  return (
    <label className={`${classe} flex flex-col gap-2`} key={fieldName}>
      {label && <Label>{label}</Label>}
      <div onClick={() => handleChange(fieldName, !value)}>
        <button
          type="button"
          className={`relative w-10 h-6 flex items-center rounded-full p-[4px] transition duration-300 
            ${value ? "bg-primary-500" : "bg-gray-300"}`}
          {...extraProps}
        >
          <span
            className={`absolute w-4 h-4 bg-white rounded-full shadow-md transform transition-transform duration-300
              ${value ? "translate-x-4" : "translate-x-0"}`}
          />
        </button>
      </div>
    </label>
  );
};

export default Switch;
